import { $t } from '../../composables/i18n'
import { Color } from '../color/Color'
import { Codebook } from '../Codebook'

export enum DefectStatusId {
  FIXED = 1,
  NOT_FIXED = 2,
  FIX_IN_PROGRESS = 3,
  INSPECTION = 4,
}

export class DefectStatus extends Codebook<DefectStatusId> {
  static readonly FIXED = new DefectStatus(DefectStatusId.FIXED, () => $t('Fixed'), Color.POSITIVE)
  static readonly NOT_FIXED = new DefectStatus(
    DefectStatusId.NOT_FIXED,
    () => $t('Not fixed'),
    Color.NEGATIVE,
  )
  static readonly FIX_IN_PROGRESS = new DefectStatus(
    DefectStatusId.FIX_IN_PROGRESS,
    () => $t('Fix in progress'),
    Color.INFO,
  )
  static readonly INSPECTION = new DefectStatus(
    DefectStatusId.INSPECTION,
    () => $t('Inspection'),
    Color.WARNING,
  )

  private constructor(
    public readonly id: DefectStatusId,
    public readonly name: () => string,
    public readonly color: Color.POSITIVE | Color.NEGATIVE | Color.INFO | Color.WARNING,
  ) {
    super(id)
  }
}
